module.exports = __webpack_public_path__ + "static/media/logo.b95eaa7d.png";